import React from 'react';
import { connect } from 'react-redux';

import { setText } from '../../../../../../_actions/question-library.action'

const QuestionLabel = ({ question, label, dispatch }) => {
  return <div className="form-group">
    <label htmlFor="question"><strong>{label || 'Question'}</strong></label>
    <textarea
      onChange={(e) => { dispatch(setText(e.target.value)) }}
      value={question.text || ''}
      rows="5"
      type="text"
      className="form-control"
    ></textarea>
  </div>
}

export default connect()(QuestionLabel)